<template>
  <div class="q-mx-auto mw-form-v2-base" style="max-width: 1200px" :class="{'q-card': settings.features.card && !isMobile}">
    <template v-if="!isSent">
    <template
        v-if="(Object.keys(form).length  > 0 && Object.keys(form.screens).length  > 0 && form.screens[activeScreen] !== 'undefined')"
    >
    <div :class="{'mw-form-center': settings.features.centered}" class="q-py-md" v-if="settings.features.progressbar">
      <q-linear-progress
          class="mw-form-v2-linear-progress"
          size="20px"
          :value="progress"
          color="primary"
          stripe
      >
        <div class="absolute-full flex flex-center" v-if="settings.features.progressbar_with_percentage">
          <q-badge class="mw-form-v2-linear-progress-badge" color="white" text-color="primary" :label="progress*100 + '%'" />
        </div>
      </q-linear-progress>
    </div>
    <q-form

        @submit="onSubmit"
        @reset="onReset"
        :class="{'mw-form-center': settings.features.centered}"
    >
      <template v-if="screensVisibility[form.screens[activeScreen].id]">
        <div class="row" v-if="settings.theme.screen.title || settings.theme.screen.title_main || settings.theme.screen.text">
          <div class="col-12 q-ml-none col-md-12">
            <h5 v-if="settings.theme.screen.title" class="text-h5 q-ma-none q-pa-md mw-form-v2-screen-name">{{form.screens[activeScreen].name}}</h5>
            <h5 v-if="settings.theme.screen.title_main && form.screens[activeScreen].title" class="q-my-none q-px-md q-py-sm mw-form-v2-screen-title" v-html="form.screens[activeScreen].title"></h5>
            <div v-if="settings.theme.screen.text && form.screens[activeScreen].text" class="q-ma-none q-pa-md q-py-sm text-body2 mw-form-v2-screen-text" v-html="form.screens[activeScreen].text">
            </div>
          </div>
        </div>

          <div class="row">

        <template
                  v-for="(field, field_index) in form.screens[activeScreen].fields"
                  :key="field_index"
        >
          <div v-if="fieldsVisibility[form.screens[activeScreen].fields[field_index].id]"
               :class="getColClass(field)"
               class="q-px-md q-py-sm q-gutter-y-md q-ml-none"

          >

            <div v-if="debug" class="q-pa-none q-ma-none q-gutter-md">
              <q-badge  color="orange" >
               {{form.screens[activeScreen].fields[field_index].data_type_override ?
                  form.screens[activeScreen].fields[field_index].data_type_override :
                  form.screens[activeScreen].fields[field_index].data_type}}
              </q-badge>
              <q-badge  color="purple">
                {{form.screens[activeScreen].fields[field_index].type}}
              </q-badge>
              <q-badge outline color="secondary" v-if="form.screens[activeScreen].fields[field_index].logic">
              Logic: {{form.screens[activeScreen].fields[field_index].logic}}
              </q-badge>

              <q-badge  color="secondary" v-if="fieldValues[form.screens[activeScreen].fields[field_index].id]">
                {{fieldValues[form.screens[activeScreen].fields[field_index].id]}}
              </q-badge>
            </div>
              <field-base-component :key="form.screens[activeScreen].fields[field_index].id"
                  :field="form.screens[activeScreen].fields[field_index]"
              ></field-base-component>
          </div>
        </template>

        </div>



      </template>
      <hr class="q-separator q-separator--horizontal" aria-orientation="horizontal" v-if="settings.features.card  && !isMobile">
      <div class="row">
      <div class="col-12 q-px-md q-py-sm q-ml-none col-md-12" :class="{'q-py-md': settings.features.card  && !isMobile}">
        <q-btn
            v-if="!form.screens[activeScreen].hide_buttons"
            class="mw-form-v2-btn-submit "
            :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
            :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
            :round="!settings.theme.next.cs ? settings.theme.button.round: null"
            :outline="!settings.theme.next.cs ? settings.theme.button.outline: null"
            :push="!settings.theme.next.cs ? settings.theme.button.push: null"
            :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
            :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
            :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
            :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"
            :loading="isSending"
            :label="buttonText()" type="submit" color="primary"
            :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
        >
        </q-btn>
        <q-btn
            :rounded="settings.theme.button.rounded"
            :round="settings.theme.button.round"
            :outline="settings.theme.button.outline"
            :push="settings.theme.button.push"
            :unelevated="settings.theme.button.unelevated"
            :noCaps="settings.theme.button.noCaps"
            :glossy="settings.theme.button.glossy"
            :size="settings.theme.button.size"
            :class="{'q-ml-sm' : !form.screens[activeScreen].hide_buttons}"
            v-if="debug" label="Reset" type="reset" color="primary" flat class="mw-form-v2-btn-back" />
        <q-btn
            v-if="activeScreen > 0"
            :flat="!settings.theme.back.cs ? true: null"
            :rounded="!settings.theme.back.cs ? settings.theme.button.rounded: null"
            :round="!settings.theme.back.cs ? settings.theme.button.round: null"
            :outline="!settings.theme.back.cs ? settings.theme.button.outline: null"
            :push="!settings.theme.back.cs ? settings.theme.button.push: null"
            :unelevated="!settings.theme.back.cs ? settings.theme.button.unelevated: true"
            :noCaps="!settings.theme.back.cs ? settings.theme.button.noCaps: null"
            :glossy="!settings.theme.back.cs ? settings.theme.button.glossy: null"
            :size="settings.theme.back.cs ? settings.theme.back.size: settings.theme.button.size"
            :class="{'q-ml-sm' : !form.screens[activeScreen].hide_buttons || debug, 'mw-form-v2-btn-back-cs':  settings.theme.back.cs}"
            label="Back" type="button" @click="onBack" color="primary" class="mw-form-v2-btn-back" />

        <q-btn
            v-if="review_visible && activeScreen < Object.keys(form.screens).length  - 1"
            :rounded="settings.theme.button.rounded"
            :round="settings.theme.button.round"
            :outline="settings.theme.button.outline"
            :push="settings.theme.button.push"
            :unelevated="settings.theme.button.unelevated"
            :noCaps="settings.theme.button.noCaps"
            :glossy="settings.theme.button.glossy"
            :size="settings.theme.button.size"
            :class="{'q-ml-sm' : !form.screens[activeScreen].hide_buttons}"
            @click="gotoReviewAndSubmitScreen"
            label="Review and Submit" type="reset" color="primary" flat class="mw-form-v2-btn-back" />

      </div>
      </div>
    </q-form>
    </template>
    <q-inner-loading :showing="isLoading">
      <q-spinner-gears size="50px" color="primary" />
    </q-inner-loading>
    </template>
    <template v-if="isSent && form">
<!--      <button @click="avatarStart">Start</button>-->
      <div class="mw-form-v2-thank-you" >

        <video ref="avatarCustom"  class="mw-form-v2-thank-you-avatar mw-form-v2-thank-you-avatar-custom"  id="video" v-show="avatar_custom_visible">
          <source :src="avatar_custom" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
        <video  ref="avatarDefault"  class="mw-form-v2-thank-you-avatar mw-form-v2-thank-you-avatar-default" id="video2" v-show="avatar_default_visible">
          <source :src="avatar_default" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>

        <div  class="text-center q-gutter-md" v-if="form.success_title">
          <h5 class="text-center q-mb-md mw-form-v2-thank-you-title" v-if="form.success_title" v-html="form.success_title"></h5>
          <div class="text-body1 mw-form-v2-thank-you-text" v-if="form.success_text" v-html="form.success_text"></div>
        </div>

        <div class="text-center q-gutter-md" v-if="!form.success_title">
          <q-icon name="s_done" color="teal" size="4.4em" />
          <h5 class="text-center q-mb-md mw-form-v2-thank-you-title">Thank you!</h5>
          <div class="text-body1 mw-form-v2-thank-you-text">We will contact you soon</div>
        </div>

      </div>
    </template>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { Notify } from 'quasar'
import FieldBaseComponent from "@/components/FieldBaseComponent";
import {fieldColSizes} from "@/components/collection";
import {mapActions} from "vuex";
import {sendData} from "@/helpers/form";
import {redirectParent} from "@/helpers/iframe";
import {closeLostForm} from "@/helpers/lostForm";
import {nextTick} from 'vue'


export default {
  data() {
    return {
      isSending: false,
      isSent: false,
      window_width: false,
      avatar_custom: null,
      avatar_default: null,
      //avatar_custom: "https://apis.elai.io/public/video/6499c2563a54644696853e7a.mp4?s=6a17a3678098fe56c4ef7639c4ecfeda0dac5d156fbed51dd1369a6720f20316",
      //avatar_default: "https://apis.elai.io/public/video/64992edbc9d135089be2d565.mp4?s=b090e19584b10cdb855324642f304075b8aba2e51431b0358876ffabb6352caa",
      avatar_custom_visible: false,
      avatar_custom_load: true,
      avatar_default_visible: false
    };
  },
  components: {
    FieldBaseComponent
  },
  methods: {
    ...mapActions({
      next: 'values/list/next',
      back: 'values/list/back',
      setScreen: 'values/list/setScreen',
      nextScreen: 'values/list/nextScreen',
      backScreen: 'values/list/backScreen'
    }),
    buttonText() {
      return Object.keys(this.form.screens).length ===this.activeScreen + 1 ?
          this.form.submit_button_text :
          (this.form.screens[this.activeScreen].next_button_text ? this.form.screens[this.activeScreen].next_button_text : 'Next');
    },
    lostForm() {
      console.log("lostForm");
    },
    onSubmit () {

      const count = Object.keys(this.form.screens).length;
      if(count > (this.activeScreen+1)) {
        this.nextScreen({form : this.form});
      } else {
        this.isSending = true;
        this.recaptcha();
      }
    },
    getColClass (field) {
      let size = 6;
      if(this.form.layout_grid_size) {
        size = Math.round(12 / this.form.layout_grid_size);
      }
      if(this.form.screens[this.activeScreen].layout_grid_size) {
        size = Math.round(12 / this.form.screens[this.activeScreen].layout_grid_size);
      }

      const type = field.data_type_override ? field.data_type_override : field.data_type;
      if(Object.hasOwn(fieldColSizes,type)) {
        size = fieldColSizes[type];
      }
      if(field.layout_grid_size) {
        size = Math.round(12 / field.layout_grid_size);
      }

      const mediaSizes = {
        1: "xs",
        2: "sm",
        3: "md",
        4: "lg",
        5: "xl",
      };

      let mediaSize = "md";
      if(this.form.layout_column_size) {
        mediaSize = mediaSizes[this.form.layout_column_size];
      }
      if(this.form.screens[this.activeScreen].layout_column_size) {
        mediaSize = mediaSizes[this.form.screens[this.activeScreen].layout_column_size];
      }
      if(field.layout_column_size) {
        mediaSize = mediaSizes[field.layout_column_size];
      }

      return mediaSize !== 'xs' ? 'col-'+ mediaSize + '-' + size + ' col-12' : 'col-'+ mediaSize + '-' + size;
    },
    onReset () {
      //Notify.create('reset')
    },
    onBack () {
      this.backScreen({form : this.form});
    },
    async recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')
      //const token = "12121212";
      // Do stuff with the received token.

      sendData(this.form, this.fieldValues, token, this.fieldsVisibility)
          .then(
              (response) => {
                this.isSending = false;
                if(response.success === undefined || !response.success) {
                  let errorBlock = '';
                  for(let key in response.error) {
                    errorBlock += '<p style="color: red">'+response.error[key]+'</p>';
                  }
                  Notify.create(  //'Something went wrong');
                  {
                        message: '<p><em>Something went wrong</em></p>' + errorBlock,
                        html: true,
                        timeout:5000
                  });
                  //console.log(response);
                } else {
                  //Notify.create('Submitted');
                  this.isSent = true;
                  if(response.message
                      && (
                          response.message.avatar_custom !== undefined
                          || response.message.avatar_lo  !== undefined
                      )
                  ) {
                    if(response.message.avatar_custom !== undefined) {
                      this.avatar_custom = response.message.avatar_custom;
                    }
                    if(response.message.avatar_lo !== undefined) {
                      this.avatar_default = response.message.avatar_lo;
                    }
                    this.avatarStart();
                  }

                  closeLostForm(this.form);
                  this.submitEvent();
                }
              })
          .catch(error => console.log(error));
    },
    avatarStart() {
      console.log(this.avatar_custom);
      console.log(this.avatar_default);
      if(this.avatar_custom && this.avatar_default) {
        this.avatar_custom_visible = true;
        nextTick(() => {
          this.$refs.avatarCustom.play();
          this.$refs.avatarCustom.addEventListener("ended", () => {
            this.avatar_custom_visible = false;
            this.avatar_default_visible = true;
            this.$refs.avatarDefault.play();
          });
        })
      }
      if(!this.avatar_custom && this.avatar_default) {
        this.avatar_custom_visible = false;
        this.avatar_custom_load = true;
        this.avatar_default_visible = true;
        nextTick(() => {
          this.$refs.avatarDefault.play();
        })
      }
    },
    submitEvent() {
      try {
        const event =new Function (this.form.submit_event);
        event();
        if(this.debug) {
          Notify.create('Submit event executed');
        }
        this.redirectEvent();
      } catch (e) {
        console.log(e);
      }
    },
    redirectEvent() {
      if(this.form.redirect_url) {
        redirectParent(this.form.redirect_url);
      }
    },
    reportWindowSize() {
      this.window_width = window.innerWidth;
    },
    gotoReviewAndSubmitScreen() {
      this.setScreen({'screen' : this.review_index});
    }
  },
  computed: {
    ...mapFields('settings/list', {
      error: 'error',
      form: 'form',
      isLoading: 'isLoading',
      settings: "settings"
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues',
      activeScreen: 'activeScreen',
      fieldsVisibility: 'fieldsVisibility',
      screensVisibility: 'screensVisibility',
      debug: "debug",
      review_visible: "review_visible",
      review_index: "review_index"

    }),
    progress: function () {
      const count = Object.keys(this.form.screens).length;
      const value = (this.activeScreen + 1)/count;
      return this.form ? parseFloat(value.toFixed(2)) : 0;
    },
    isMobile: function (){
      return this.window_width < 821
    },
  },
  mounted() {
    this.reportWindowSize();
    window.addEventListener("resize", this.reportWindowSize);
  }
}
</script>
<style>
.mw-form-v2-thank-you-avatar {
  max-width: 100%;
  max-height: 70%;
  width: 100%;
}
.mw-form-center .mw-form-v2-field {
  max-width: 500px;
}

.mw-form-center .mw-form-v2-field {
  max-width: 500px;
  margin-left:auto;
  margin-right: auto;
}

/*.mw-form-center .f_select_buttons_full_size {*/
/*  margin-left: 28px;*/
/*}*/

.mw-form-center .mw-form-v2-btn-gutter {
  margin-left: auto;
  margin-right: auto;
}
.mw-form-center .mw-form-v2-screen-title {
  margin-left: 0;
}
.mw-form-center {
  text-align:center;
}
.mw-w-100 {
  width: 100% !important;
}
.q-field:not(.q-field--float) .mw-optional-label , .mw-form-v2-label .mw-optional-label  {
  font-size: 7pt;
}

.mw-form-v2-linear-progress {
  max-width: 600px;
  margin-left: auto !important;
  margin-right: auto;
}
.q-invisible {
  visibility: hidden;
  width: 0;
  height: 0;
  display: block;
}

</style>